import axiosClient from "../../../shared/lib/http/axiosClient";
import { DocumentPayment } from "@models/document-payment";

export const getDocumentPayments = async (sortKey = "id", maxRecords = "0", sortMethod = "asc", load: string[], body: object = {}, signal: AbortSignal): Promise<DocumentPayment[]> => {
  
  const loadString = `?load=${load.join(",")}`;
  
  const response = await axiosClient.post(
    `/api/documents-payments/search/${maxRecords}/${sortKey}/${sortMethod}${loadString}`,
    body,
    {signal},
  );

  return response.data;
};
